( function ( _s ) {
	const getDirectSiblingButtons = ( _button, _siblings = _s( '' ) ) => {
		if ( _button?.length ) {
			const button = _button.firstElement();
			const nextSibling = button.nextElementSibling;
			const _nextSibling = _s( nextSibling );

			if ( _nextSibling.hasClass( 'cta-button' ) ) {
				_siblings = _siblings.add( nextSibling );

				_siblings = getDirectSiblingButtons( _s( nextSibling ), _siblings );
			}
		}

		return _siblings;
	};

	_s.fn.buttonGroup = function () {
		return this.el.forEach( el => {
			let _button = _s( el );
			const _parent = _button.parent();

			if ( ! _parent.hasClass( 'cta-button-group' ) ) {
				const _siblingButtons = getDirectSiblingButtons( _button );

				if ( _siblingButtons.length ) {
					_siblingButtons.each( siblingButton => {
						_button = _button.add( siblingButton );
					} );
					_button.wrapAll( '<div class="cta-button-group"></div>' );
				}
			}
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '#main .cta-button' );

		if ( _elements.length ) {
			_elements.buttonGroup();
		}
	} );
} )( window._s );
